import { Checkbox, CheckboxProps } from '@mui/material'
import React, { FC } from 'react'

export type C1CheckboxProps = Omit<CheckboxProps, 'variant'>

export const C1Checkbox: FC<C1CheckboxProps> = (props) => <Checkbox {...props} />
